import axios from 'axios'
import Api from './index';
import Vue from 'vue';
// import store from '../store';
import router from '../router/index';
import { Loading } from 'element-ui';
let vm = new Vue();
let baseURL = process.env.VUE_APP_SERVER_URL 
// let   baseURL = "http://api.gyaii.com/api"
const instance = axios.create({
  baseURL: baseURL,
  timeout: 50000,
  headers: {
      'Accept': 'application/json',
  }
})
let loading;
let loadingNum = 0;  //  内存中正在请求的数量
function startLoading() {
    if(loadingNum == 0) {
        loading = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background:'rgba(255,255,255,0.5)',
            // target: document.querySelector('.container')
        })
    }
    loadingNum++;
}
function endLoading() {  //  关闭加载动画
    loadingNum--;
    if(loadingNum <= 0) {
        loading.close();
    }
}

const refreshToken = axios.create({
  baseURL:baseURL,
  headers: {
      'Accept': 'application/json',
  }
})
// 请求拦截

instance.interceptors.request.use(
  config => {
    startLoading();
    if (sessionStorage.getItem('token') && sessionStorage.getItem('token') != '') {
    config.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
          // config.headers.timestamp = new Date().getTime();
    }
    
    
  return config;
}, error => {
  return Promise.reject(error);
})
 
// 响应拦截
 instance.interceptors.response.use(response => {
  endLoading();  //  关闭加载动画
  const resCode = response.status;
 
  if (resCode === 200) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(response);
    
  }
  // return response
}, async  error => {
  endLoading();  //  关闭加载动画
  const resCode = error.response.status;
  switch (resCode) {
    case 401:
      if(router.currentRoute.name !== 'login'){
        try {
        const {data} = await refreshToken({
        method:"GET",
        url:"admin/refresh-token",
        headers:{
          'Accept': 'application/json',
          Authorization:`Bearer ${sessionStorage.getItem('token')}`,
        }
          })
        
        
          sessionStorage.setItem("token" ,data.data.access_token)
          config.headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
          return request(error.config)
        } catch (error) {
          router.replace({
            name: 'login'
          });
        }
 
      }else{
        vm.$Message.error(error.response.data.message);
        router.replace({
          name: 'login'
        });
      }

      break;
    case 404:
      vm.$Message.error('网络请求不存在');
      break;
    case 500:
      vm.$Message.error('服务器连接错误');
      break;
    // 其他状态码错误提示
    default:
      return vm.$Message.error(error.response.data.message);  
  }
  return Promise.reject(error);
})
 
/*
 *封装get方法
 *@param{String} url [请求地址]
 *@param{Object} params 请求参数
 */
export function Get(url, params,) {
  return new Promise((resolve, reject) => {
    instance.get(url, {
      params: params
      

      
    }).then((res) => {
      resolve(res.data);
    }).catch((error) => {
      reject(error.data);
  
    })
  })
}
 
/**
 *封装post方法
 *@param{String} url 请求地址
 *@param{Object} params 请求参数
 */
export function Post(url, params) {
  return new Promise((resolve, reject) => {
    instance.post(url, params).then((res) => {
      resolve(res.data);
    }).catch((error) => {
      reject(error.data);
  
    })
  })
}

/**
 *封装delete方法
 *@param{String} url [请求地址]
 *@param{Object} params [请求参数]
 */
export function Delete(url, params) {
  return new Promise((resolve, reject) => {
    instance.delete(url, {
      params: params
    }).then((res) => {
      resolve(res.data);
    }).catch((error) => {
      reject(error.data);
    })
  })
}
export {
  baseURL,

}